export default __webpack_public_path__ + "static/media/competition days.6103161a.jpg";